import axios from "axios";
import { API_DETAILS } from "../App";
import { clearSessionCookies } from "./sessionCookies";

/**
 * The one way to sign out, used by every sign-out button.
 *
 * There were six copies. Each deleted the browser's cookies and nothing else:
 * the token went on working until it expired a week later, the patient's name
 * cookie was left behind in some of them, and the provider and admin ones left
 * the chat socket connected. This asks the server to end the session — which
 * refuses every token the account was issued, on every device — then clears
 * what the app keeps, and loads the destination as a new page, which closes the
 * chat socket and drops everything held in memory.
 */
export async function signOut(destination = "/") {
  try {
    await axios.post(API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/auth/logout");
  } catch (err) {
    // Signing out locally still happens. The server answers this the same way
    // whether or not the session was valid, so a failure here is a network one.
  }
  clearSessionCookies();
  window.location.assign(destination);
}
